import React from "react";
import { Link } from "react-router-dom";
import { FaRegFilePdf } from "react-icons/fa6";
import { GoDownload } from "react-icons/go";
import { RiDeleteBinLine } from "react-icons/ri";
import { SlSizeFullscreen } from "react-icons/sl";
import { GrDocumentImage } from "react-icons/gr";
import document from "../../assets/document.png";
import { MdOutlineFileUpload } from "react-icons/md";
import {
  hasFormButtonLink,
  type FormCardStatus,
} from "./formCardPresentation";

interface DocumentsListProps {
  title?: string;
  text?: string;
  buttontext: string;
  statusColor: string;
  statusBorderColor: string;
  statusTextColor: string;
  dotColor: string;
  buttonBg: string;
  buttonTextColor: string;
  status?: FormCardStatus;
  link?: string; // optional link prop
  showUnreadBadge?: boolean;
  /** Shown in the status pill after "Feedback Received", e.g. (3) */
  feedbackPendingCount?: number;
}

const DocumentsList: React.FC<DocumentsListProps> = ({
  title,
  text,
  buttontext,
  dotColor,
  status,
  statusColor,
  statusBorderColor,
  statusTextColor,
  buttonBg,
  buttonTextColor,
  link,
  showUnreadBadge = false,
  feedbackPendingCount,
}) => {
  const hasLink = hasFormButtonLink(buttontext);

  const ButtonContent = (
    <span className="relative inline-block">
      <button
        className="text-base font-semibold py-[7px] px-[24px] text-white rounded-full"
        style={{
          backgroundColor: buttonBg,
          color: buttonTextColor,
        }}
      >
        {buttontext}
      </button>
      {showUnreadBadge && (
        <span
          className="absolute -top-0.5 right-2 w-2 h-2 rounded-full bg-red-500 ring-2 ring-white"
          title="Action required - unread feedback"
          aria-label="Unread feedback"
        />
      )}
    </span>
  );

  return (
    <div className="visaCard border border-gray-200 p-4 md:flex block rounded-2xl mb-3 justify-between items-center">
      {/* Left Section */}
      <div className="flex md:w-[70%] w-full md:items-center items-start md:mb-0 mb-4">
        <div className="flex md:items-center items-start">
          <div
            className="w-[12px] h-[12px] rounded-[50%] md:me-4 me-2 md:mt-0 mt-2"
            style={{ backgroundColor: dotColor }}
          ></div>
          <p className="text-base md:w-auto w-[90%]">
            {title}
            <br />
            <span className="text-sm text-[#4B5563]">{text}</span>
          </p>
        </div>
      </div>

      {/* Right Section */}
      <div className="flex justify-between items-center">
        {(status === "Uploaded" ||
          status === "Completed" ||
          status === "Feedback Received") && (
          <label
            className="text-sm py-1 px-4 rounded-[50px] me-3 mb-0 whitespace-nowrap"
            style={{
              backgroundColor: statusColor,
              border: "1px solid",
              borderColor: statusBorderColor,
              color: statusTextColor,
            }}
          >
            {status === "Feedback Received"
              ? `Feedback Received${
                  feedbackPendingCount != null && feedbackPendingCount > 0
                    ? ` (${feedbackPendingCount})`
                    : ""
                }`
              : status}
          </label>
        )}

        {/* Form actions navigate to the existing form route. */}
        {hasLink && link ? (
          <Link to={link}>{ButtonContent}</Link>
        ) : (
          ButtonContent
        )}
      </div>
    </div>
  );
};

export default DocumentsList;
